<template>
  <result-list />
</template>
<script>
import ResultList from "@/components/ResultList.vue";
import { Condenado } from "@/models.js";
import store from "@/store.js";

export default {
  components: {
    ResultList,
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: "fetchData",
  },
  methods: {
    fetchData: function () {
      const query = Object.assign({}, this.$route.query);
      store.state.query = query;
      Condenado.fetchMany(query);
    },
  },
  data() {
    return {
      Condenado,
      state: store.state,
    };
  },
};
</script>
